/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Tag } from '../models/Tag';
import type { TagCriteriaRequest } from '../models/TagCriteriaRequest';
import type { TagRegularRequest } from '../models/TagRegularRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TagsService {

    /**
     * Returns the list of tags for user's company
     * @returns any Success
     * @throws ApiError
     */
    public static getTagList({
        type,
        withStat,
        name,
        limit,
        offset,
        isCriteriaBased,
        ignorePagination,
    }: {
        type?: string,
        withStat?: boolean,
        name?: string,
        limit?: number,
        offset?: number,
        isCriteriaBased?: boolean,
        ignorePagination?: boolean,
    }): CancelablePromise<{
        count?: number;
        rows: Array<Tag>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tag',
            query: {
                'type': type,
                'withStat': withStat,
                'name': name,
                'limit': limit,
                'offset': offset,
                'isCriteriaBased': isCriteriaBased,
                'ignorePagination': ignorePagination,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Add tag into the current user's company
     * @returns Tag Success
     * @throws ApiError
     */
    public static addTag({
        requestBody,
    }: {
        /**
         * Name of the tag
         */
        requestBody: (TagCriteriaRequest | TagRegularRequest),
    }): CancelablePromise<Tag> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/tag',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Edit tag
     * @returns Tag Success
     * @throws ApiError
     */
    public static editTag({
        tagId,
        requestBody,
    }: {
        /**
         * Tag Id
         */
        tagId: number,
        requestBody: (TagCriteriaRequest | TagRegularRequest),
    }): CancelablePromise<Tag> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/tag/{tagId}',
            path: {
                'tagId': tagId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found or have no access`,
            },
        });
    }

    /**
     * Delete tag
     * @returns any Success
     * @throws ApiError
     */
    public static deleteTag({
        tagId,
    }: {
        tagId: number,
    }): CancelablePromise<{
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/tag/{tagId}',
            path: {
                'tagId': tagId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found or have no access`,
            },
        });
    }

}
